import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recursos_financieros',
  templateUrl: './recursos_financieros.component.html',
  styleUrls: ['./recursos_financieros.component.css']
})
export class Recursos_financierosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
